import React from 'react';
import { Link, Table, Tag, Text } from '@nimbus-ds/components';

export function HomeTableRowsSkeleton(): JSX.Element {
  const rowsMapped = [];
  for (let i = 0; i < 20; i++) {
    rowsMapped.push(
      <Table.Row key={i} id={`${i}`}>
        <Table.Cell>
          <Link.Skeleton />
        </Table.Cell>
        <Table.Cell>
          <Text.Skeleton />
        </Table.Cell>
        <Table.Cell>
          <Text.Skeleton />
        </Table.Cell>
        <Table.Cell>
          <Text.Skeleton />
        </Table.Cell>
        <Table.Cell>
          <Tag.Skeleton />
        </Table.Cell>
      </Table.Row>,
    );
  }
  return <>{rowsMapped}</>;
}
